
define('tpl!taoQtiItem/qtiCreator/tpl/inlineInteraction/inlineChoice', ['handlebars'], function(hb){ 
return hb.template(function (Handlebars,depth0,helpers,partials,data) {
  this.compilerInfo = [4,'>= 1.0.0'];
helpers = this.merge(helpers, Handlebars.helpers); data = data || {};
  var buffer = "", stack1, helper, functionType="function", escapeExpression=this.escapeExpression, self=this;

function program1(depth0,data) {
  
  
  return "pin";
  }

function program3(depth0,data) {
  
  
  return "shuffle";
  }

function program5(depth0,data) {
  
  var buffer = "";
  return buffer;
  }

function program7(depth0,data) {
  
  
  return "display:none;";
  }

  buffer += "<tr class=\"widget-box widget-inlineChoice qti-choice\" data-edit=\"active\" data-serial=\"";
  if (helper = helpers.serial) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.serial); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "\">\n    <td class=\"option\"><div class=\"editable-content\" contenteditable=\"true\">";
  if (helper = helpers.body) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.body); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "</div></td>\n    <td class=\"mini-tlb\">\n        <span data-edit=\"question\" class=\"tlb-button\">\n            <span  class=\"icon-";
  stack1 = helpers['if'].call(depth0, ((stack1 = (depth0 && depth0.attributes)),stack1 == null || stack1 === false ? stack1 : stack1.fixed), {hash:{},inverse:self.program(3, program3, data),fn:self.program(1, program1, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\" data-role=\"shuffle-pin\" style=\"";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.interactionShuffle), {hash:{},inverse:self.program(7, program7, data),fn:self.program(5, program5, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\"></span>\n        </span>\n        <label data-edit=\"map\">\n            <input name=\"correct\" type=\"radio\" value=\"";
  if (helper = helpers.serial) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.serial); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "\">\n            <span class=\"icon-radio\"></span>\n        </label>\n    </td>\n    <td class=\"mini-tlb\">\n        <span data-edit=\"question\" class=\"icon-bin\" data-role=\"delete\"></span>\n        <input class=\"score\" name=\"score\" data-edit=\"map\" value=\"";
  if (helper = helpers.score) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.score); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "\" data-for=\"";
  if (helper = helpers.serial) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.serial); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "\" data-validate=\"$numeric\" data-validate-option=\"$allowEmpty; $event(type=keyup)\"/>\n    </td>\n</tr>";
  return buffer;
  });
});

